import { PayloadType, QuestionnaireStateType } from "@/common/types";
import Types from "@/redux/types";

const questionnaireInitialState: QuestionnaireStateType = {
  questionnaires: null,
  questionnaireDetail: null,
  questionnaireDetailByTestKit: null,
};

export const questionnaireReducer = (
  state = questionnaireInitialState,
  action: PayloadType
) => {
  switch (action.type) {
    case Types.SET_QUESTIONNAIRES:
      return {
        ...state,
        questionnaires: action.payload,
      };
    case Types.SET_QUESTIONNAIRE_DETAIL:
      return {
        ...state,
        questionnaireDetail: action.payload,
      };
    case Types.SET_QUESTIONNAIRE_DETAIL_BY_TEST_KIT:
      return {
        ...state,
        questionnaireDetailByTestKit: action.payload,
      };
    default:
      return state;
  }
};
